
































import { Component, Vue, PropSync } from "vue-property-decorator";
import { TipoModalEnum } from "./TipoModalEnum";
import { DadosModal } from "./DadosModal";

@Component
export default class GsModal extends Vue {
  @PropSync("dadosModal", { required: true })
  dadosModalSynced!: DadosModal;

  get tipoModal() {
    const cssClass = " titulo";
    switch (this.dadosModalSynced.tipo) {
      case TipoModalEnum.ERRO:
        return `${cssClass} erro`;
      case TipoModalEnum.SUCESSO:
        return `${cssClass} sucesso`;
      case TipoModalEnum.ALERTA:
        return `${cssClass} alerta`;
      default:
        return `${cssClass} padrao`;
    }
  }
}
